import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const ProductItemUpdateModalUI = ({ context, messageList, successMsg, errorList, setErrorList, inventoryItemList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // maker
  maker, onMakerChange, makerError, setMakerError, makerUpdated,
  // item name
  name, onItemNameChange, itemNameError, setItemNameError, itemNameUpdated,
  // category
  category, onCategoryChange, categoryError, setCategoryError, categoryUpdated,
  // mrp
  mrp, onPriceChange, priceError, setPriceError, priceUpdated
}) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_update_product_item'
    buttonMessageKey='c_update'
    cancelMessageKey='c_cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF name='maker' required={true} maxLength={40}
      messageList={messageList} labelKey='c_maker_name'
      value={makerUpdated ? maker : (inventoryItemList && inventoryItemList.length > 0 && inventoryItemList.filter(product => product.selected).length > 0 ? inventoryItemList.filter(product => product.selected)[0].maker : '')}
      onChange={onMakerChange} error={makerError} setError={setMakerError}
      autoFocus={true}
    />
    <InputTextSF name='name' required={true} maxLength={40}
      messageList={messageList} labelKey='c_item_name'
      value={itemNameUpdated ? name : (inventoryItemList && inventoryItemList.length > 0 && inventoryItemList.filter(product => product.selected).length > 0 ? inventoryItemList.filter(product => product.selected)[0].name : '')}
      onChange={onItemNameChange} error={itemNameError} setError={setItemNameError}
      autoFocus={true}
    />
    <InputTextSF name='category' required={true} maxLength={40}
      messageList={messageList} labelKey='c_category'
      value={categoryUpdated ? category : (inventoryItemList && inventoryItemList.length > 0 && inventoryItemList.filter(product => product.selected).length > 0 ? inventoryItemList.filter(product => product.selected)[0].category : '')}
      onChange={onCategoryChange} error={categoryError} setError={setCategoryError}
      autoFocus={true}
    />
    <InputTextSF type='mrp' name='mrp' required={true} maxLength={13}
      messageList={messageList} labelKey='c_price'
      value={priceUpdated ? mrp : (inventoryItemList && inventoryItemList.length > 0 && inventoryItemList.filter(product => product.selected).length > 0 ? inventoryItemList.filter(product => product.selected)[0].mrp : '')}
      onChange={onPriceChange} error={priceError} setError={setPriceError}
      autoFocus={true}
    />
  </ModalFormUI>

export default ProductItemUpdateModalUI
